import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HighlightService } from 'src/app/@core/services/highligh.service';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss']
})
export class TextareaComponent implements OnInit {

  utils: any;
  highlighted: boolean = false;
  codeHtml: string;
  codeJs: string;
  infoComponent: { titulo: string; descripcion: string; };
  constructor(
    private sanitizer: DomSanitizer,
    private highlightService: HighlightService) {
    this.utils = window.utils;
    this.codeHtml = `
<textarea class="form-control" rows="5" placeholder="Escribe aquí tu opinión" id="textarea-example" maxlength="300">
</textarea>`;
    this.codeJs = `
utils.init();
utils.countCharacter("textarea-example", 300);`;

    this.infoComponent = {
      titulo: "Textarea",
      descripcion: "Control para la entrada de texto multilínea. En el siguiente ejemplo pude limitar el número de caracteres permitidos a través del atributo <code>maxlenght</code>"
    }
  }

  ngAfterViewChecked() {
    if (!this.highlighted) {
      this.highlightService.highlightAll();
      this.highlighted = true;
    }
  }

  ngOnInit() {
    this.utils.init();
    this.utils.countCharacter("textarea-example", 300);
  }

}
